import { t } from '../../shared/config/translations'

export function collectionImportNoticeTemplate(
	id: string,
	closeButtonId?: string,
): string {
	return `<aside id="${id}" class="collection-import-notice" role="status" hidden>
		<svg aria-hidden="true"><use href="#symbols-info-circle"></use></svg>
		<p>${t('collection.importNotice')}</p>
		${closeButtonId ? `<button type="button" id="${closeButtonId}" class="btn icon noFrame small" aria-label="Dismiss collection import notice">×</button>` : ''}
	</aside>`
}
